module.exports = __webpack_public_path__ + "img/recommend1-1.91bfc0f9.png";